export const GET_ALL_CENTROS_DE_CUSTO = 'GET_ALL_CENTROS_DE_CUSTO'
